import CompanyRealtor from '@pages/company-realtor';
import Offer from '@pages/offer';
import RealtorBooking from '@pages/realtor-booking';
import { decryptUserStorage } from '@reducers/UserSlice';
import { Permissions } from '@utils/constants/permissions';

// import RealtorFlat from '@pages/realtor-flat';
import { realtorPaths } from './paths';

// const Offer = lazy(() => import('@pages/offer'));
// const RealtorAll = lazy(() => import('@pages/realtor-all'));
// const RealtorFlat = lazy(() => import('@pages/realtor-flat'));
// const RealtorBooking = lazy(() => import('@pages/realtor-booking'));

const user = decryptUserStorage;

const routes = [
  {
    component: Offer,
    path: realtorPaths.OFFER,
    permission: [Permissions.PERMISSION_OFFER]
  },
  {
    component: RealtorBooking,
    path: realtorPaths.BOOKING,
    permission: [Permissions.PERMISSION_REALTOR_BOOKING]
  },
  // {
  //   path: realtorPaths.FLAT,
  //   component: RealtorFlat
  // },
  {
    path: realtorPaths.COMPANY_REALTOR,
    component: CompanyRealtor
  }
];

export const realtorRoutes: typeof routes = [];

if (typeof user === 'object' && user) {
  routes.forEach(route => {
    if (route.permission) {
      if (user?.role) {
        if (route.permission?.every(p => user.role.permissions.includes(p))) {
          realtorRoutes.push(route);
        }
      } else if (user?.roleTokens && route.permission?.every(p => user.roleTokens![0]?.role?.permissions.includes(p))) {
        realtorRoutes.push(route);
      }
    } else {
      realtorRoutes.push(route);
    }
  });
}
